<template>
    <router-view></router-view>
</template>

<script>
import cookie from 'js-cookie'

cookie.set('paas_env', 'dev')

export default {
    name: 'PaasConsole',
    computed: {
    }
}
</script>
